<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <h4><i class="fas fa-boxes"></i> ใบขอซื้อ</h4>

          <b-card no-body>
            <b-tabs
              card
              v-model="tabIndex"
              @input="onTabChange"
            >
              <b-tab>
                <template #title>
                  ใบวางแผนความต้องการวัสดุ ({{ getMrpLength }})
                  <span
                    v-if="isShowRedDot > 0"
                    class="tab-red-dot"
                  ></span>
                </template>
                <div
                  class="row"
                  style="margin: 0px 0px 20px 0px"
                >
                  <b-form-input
                    type="search"
                    class="col"
                    autofocus
                    v-model="filter"
                    placeholder="ค้นหารหัสใบวางแผนความต้องการวัสดุ"
                  ></b-form-input>
                </div>
                <b-table
                  id="mrpTable"
                  ref="mrpTable"
                  hover
                  small
                  sort-icon-left
                  head-variant="light"
                  sort-by="creationDt"
                  :items="getMrpList"
                  :fields="mrpFields"
                  :filter="filter"
                  :filter-included-fields="['no']"
                  :sort-desc="true"
                  :sort-compare="mrpSortCompare"
                  :responsive="true"
                >
                  <template v-slot:cell(index)="row"
                    >{{ row.index + 1 }}.</template
                  >
                  <template v-slot:cell(no)="row">
                    {{ row.item.no }}
                  </template>
                  <template v-slot:cell(creationDt)="row">{{
                    formatDate(row.item.creationDt)
                  }}</template>

                  <template v-slot:cell(buttons)="row">
                    <div class="action-button-group">
                      <ActionButtonGroup
                        :item="row.item"
                        :show-delete="false"
                        :show-edit="false"
                        :show-info="true"
                        infoTooltip="ดูข้อมูลใบวางแผน<br />ความต้องการวัสดุ"
                        @info="openMrpDetailItemModal(row.item)"
                      />
                      <b-button
                        variant="primary"
                        @click="openMrpToCreateModal(row.item)"
                      >
                        แปลงเป็นใบขอซื้อ
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </b-tab>
              <b-tab title="ใบขอซื้อ">
                <div
                  class="row"
                  style="margin: 0px 0px 20px 0px"
                >
                  <b-form-input
                    type="search"
                    class="col"
                    autofocus
                    v-model="filter"
                    placeholder="ค้นหาใบขอซื้อ จากรหัสใบขอซื้อ หรือรหัสใบวางแผนความต้องการวัสดุ"
                  ></b-form-input>
                </div>
                <b-table
                  id="prTable"
                  ref="prTable"
                  hover
                  small
                  sort-icon-left
                  head-variant="light"
                  sort-by="creationDt"
                  :items="getPrList"
                  :fields="prFields"
                  :filter="filter"
                  :filter-included-fields="['no', 'mrpNo']"
                  :sort-desc="true"
                  :sort-compare="prSortCompare"
                  :responsive="true"
                >
                  <template v-slot:cell(index)="row"
                    >{{ row.index + 1 }}.</template
                  >
                  <template v-slot:cell(status)="row">
                    <PrStatusBadge :status="row.item.status" />
                  </template>

                  <template v-slot:cell(creationDt)="row">{{
                    formatDate(row.item.creationDt)
                  }}</template>

                  <template v-slot:cell(buttons)="row">
                    <template
                      v-if="
                        row.item.transferStatus === Status.PENDING &&
                        isAccessMenu([ROLES.ROLE_BRANCH_STOCK_MANAGER])
                      "
                    >
                      <button
                        class="btn btn-primary check-btn"
                        @click="
                          openTransferDetailItemModal(
                            row.item,
                            row.item.transferStatus === Status.PENDING
                          )
                        "
                      >
                        ตรวจสอบ
                      </button>
                    </template>
                    <ActionButtonGroup
                      :item="row.item"
                      :show-delete="false"
                      :show-edit="true"
                      :disabledEdit="!isPrEditable(row.item)"
                      editTooltip="แก้ไขใบขอซื้อ"
                      @edit="openPrToEditModal(row.item)"
                      :show-info="true"
                      infoTooltip="ดูข้อมูลใบขอซื้อ"
                      @info="
                        $router.push({
                          name: 'PurchaseRequestDetail',
                          params: {
                            clinicUrl: $route.params.clinicUrl,
                            branchUrl: $route.params.branchUrl,
                            prId: row.item.id,
                          },
                        })
                      "
                    />
                  </template>
                </b-table>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
      <CreateOrUpdatePurchaseReuqestModel
        ref="createOrUpdatePurchaseReuqestModel"
        @success="$refs.mrpDetailModal.close()"
      />
      <MrpDetailModal
        ref="mrpDetailModal"
        @convert="openCreateOrUpdatePurchaseReuqestModal"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Dialog from "../../components/modal/Dialog.vue";
import Loading from "@/components/Loading";
import { mapActions, mapGetters } from "vuex";
import ActionButtonGroup from "@/components/table/stock/button/ActionButtons.vue";
import { Status, PR_STATUS } from "../../constants/productStock";
import CreateOrUpdatePurchaseReuqestModel from "@/components/modal/ProductAndStock/PurchaseReuqest/CreateOrUpdatePurchaseReuqestModel.vue";
import MrpDetailModal from "@/components/modal/ProductAndStock/PurchaseReuqest/MrpDetailModal.vue";
import PrStatusBadge from "@/components/badge/PrStatusBadge.vue";
import { ROLES } from "@/constants/user";

export default {
  name: "TransferInventory",
  components: {
    Dialog,
    Loading,
    ActionButtonGroup,
    CreateOrUpdatePurchaseReuqestModel,
    MrpDetailModal,
    PrStatusBadge,
  },
  data() {
    return {
      ROLES,
      isLoading: false,
      mrpFields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "6%" },
          tdStyle: { width: "6%" },
        },
        {
          key: "no",
          label: "รหัสใบวางแผนความต้องการวัสดุ",
          sortable: true,
          thStyle: { width: "50%" },
          tdStyle: { width: "50%" },
        },
        {
          key: "creationDt",
          label: "วันที่สร้าง",
          sortable: true,
          thStyle: { width: "10%" },
          tdStyle: { width: "10%" },
        },
        {
          key: "buttons",
          label: "",
          class: "text-center",
          thStyle: { width: "20%" },
          tdStyle: { width: "20%" },
        },
      ],
      prFields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "6%" },
          tdStyle: { width: "6%" },
        },
        {
          key: "status",
          label: "สถานะ",
          sortable: true,
          sortByFormatted: true,
          formatter: value => {
            const order = {
              DRAFT: 0,
              SENT_TO_ERP: 4,
              PARTIALLY_ORDERED: 3,
              CLOSED: 2,
              CANCELED: 1,
            };
            return order[value] ?? 99;
          },
          thStyle: { width: "10%" },
          tdStyle: { width: "10%" },
        },
        {
          key: "no",
          label: "รหัสใบขอซื้อ",
          sortable: true,
          thStyle: { width: "22%" },
          tdStyle: { width: "22%" },
        },
        {
          key: "mrpNo",
          label: "รหัสใบวางแผนความต้องการวัสดุ",
          sortable: true,
          thStyle: { width: "25%" },
          tdStyle: { width: "25%" },
        },
        {
          key: "creationDt",
          label: "วันที่สร้าง",
          sortable: true,
          thStyle: { width: "21%" },
          tdStyle: { width: "21%" },
        },
        {
          key: "buttons",
          label: "",
          class: "text-center",
          thStyle: { width: "9%" },
          tdStyle: { width: "9%" },
        },
      ],
      Status,
      tabIndex: sessionStorage.getItem("purchaseRequestTab") === "pr" ? 1 : 0,
    };
  },
  async mounted() {
    this.isLoading = true;
    try {
      const clinicUrl = this.$route.params.clinicUrl;
      const branchUrl = this.$route.params.branchUrl;
      const promises = [
        this.fetchMrpList({ clinicUrl, branchUrl }),
        this.fetchPurchaseRequests({ clinicUrl, branchUrl }),
      ];
      await Promise.all(promises);
    } catch (err) {
      this.showDialogToast("danger", "โหลดข้อมูลไม่สำเร็จ");
      console.error(err);
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters({
      getMrpList: "moduleMrp/getMrpList",
      getMrpLength: "moduleMrp/getMrpLength",
      isShowRedDot: "moduleMrp/isShowRedDot",
      getPrList: "modulePurchaseRequest/getPrList",
      getProductList: "moduleProductInventory/getProductList",
      getPrFilter: "modulePurchaseRequest/getPrFilter",
    }),
    filter: {
      get() {
        return this.getPrFilter;
      },
      set(value) {
        this.$store.commit("modulePurchaseRequest/setFilter", value);
      },
    },
  },
  methods: {
    ...mapActions({
      fetchPurchaseRequests: "modulePurchaseRequest/fetchPurchaseRequests",
      fetchPrById: "modulePurchaseRequest/fetchPrById",
      fetchMrpList: "moduleMrp/fetchMrpList",
      fetchMrpById: "moduleMrp/fetchMrpById",
      isAccessMenu: "moduleUser/getIsAccessMenu",
    }),
    onTabChange(index) {
      sessionStorage.setItem("purchaseRequestTab", index === 1 ? "pr" : "mrp");
      this.filter = "";
    },
    isPrEditable(item) {
      return item.status === PR_STATUS.DRAFT;
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
    formatDate(date) {
      if (date) {
        return moment(date).locale("th").format("DD MMM YY");
      } else {
        return "";
      }
    },
    openTransferDetailItemModal(eventData, isPending) {
      this.isLoading = true;
      this.$store
        .dispatch("moduleTransferInventory/getTransferDetailById", {
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          id: eventData.transferId,
        })
        .then(res => {
          this.$refs.transferDetailItemModal.show({
            transferDetail: res,
            isTransferInAction: isPending,
          });
        })
        .catch(err => {
          console.error("getTransferDetailById failed", err);
          throw err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    openCreateOrUpdatePurchaseReuqestModal(mrpDetail) {
      this.$refs.createOrUpdatePurchaseReuqestModel.show({
        mrpNo: mrpDetail.no,
        mrpId: mrpDetail.id,
        products: mrpDetail.products || [],
        productList: this.getProductList,
        type: "CREATE",
      });
    },
    openMrpToCreateModal(item) {
      this.isLoading = true;
      this.fetchMrpById({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
        id: item.id,
      })
        .then(mrpDetail => {
          this.openCreateOrUpdatePurchaseReuqestModal(mrpDetail);
        })
        .catch(err => {
          console.error("fetchMrpById failed", err);
          this.showDialogToast("danger", "โหลดข้อมูลไม่สำเร็จ");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    openPrToEditModal(item) {
      this.isLoading = true;
      this.fetchPrById({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
        id: item.id,
      })
        .then(prDetail => {
          this.$refs.createOrUpdatePurchaseReuqestModel.show({
            prId: item.id,
            mrpNo: prDetail.mrpNo,
            mrpId: prDetail.mrpId,
            products: prDetail.products || [],
            productList: this.getProductList,
            type: "UPDATE",
          });
        })
        .catch(err => {
          console.error("fetchPrById failed", err);
          this.showDialogToast("danger", "โหลดข้อมูลไม่สำเร็จ");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    prSortCompare(a, b, key) {
      if (key === "creationDt") {
        const diff = new Date(a.creationDt) - new Date(b.creationDt);
        if (diff !== 0) return diff;
        return (a.no ?? "").localeCompare(b.no ?? "", undefined, {
          numeric: true,
        });
      }
      return null;
    },
    mrpSortCompare(a, b, key) {
      if (key === "creationDt") {
        const diff = new Date(a.creationDt) - new Date(b.creationDt);
        if (diff !== 0) return diff;
        return (a.no ?? "").localeCompare(b.no ?? "", undefined, {
          numeric: true,
        });
      }
      return null;
    },
    openMrpDetailItemModal(item) {
      this.isLoading = true;
      this.fetchMrpById({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
        id: item.id,
      })
        .then(mrpDetail => {
          this.$refs.mrpDetailModal.show(mrpDetail);
        })
        .catch(err => {
          console.error("fetchMrpById failed", err);
          this.showDialogToast("danger", "โหลดข้อมูลไม่สำเร็จ");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.tab-red-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #dd3333;
  border-radius: 50%;
  vertical-align: center;
}

::v-deep #mrpTable thead tr th,
::v-deep #mrpTable tbody tr td {
  vertical-align: middle !important;
}

::v-deep #mrpTable td {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #mrpTable th {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #prTable thead tr th,
::v-deep #prTable tbody tr td {
  vertical-align: middle !important;
}

::v-deep #prTable td {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #prTable th {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

.check-btn {
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 8px 24px;
  border-radius: 4px;
  width: 120px;
}

.icon-action {
  font-size: 20px !important;
  cursor: pointer;
  color: #a3a4a6;
}

.icon-info-hover:hover {
  color: #1976d2;
}

.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none !important;
  background-color: transparent !important;
}

.action-button:disabled,
.action-button--disabled {
  cursor: not-allowed !important;
  color: #ebebeb !important;
}
.action-button:disabled .icon-action,
.action-button--disabled .icon-action {
  cursor: not-allowed !important;
  color: #ebebeb !important;
}

.action-button-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}
</style>
